export default __webpack_public_path__ + "static/media/bg_faca_parte_mobile.ef0c0165.png";